import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getAffectedInserts, } from "../functions/ToggleCollidersOnDrag";
import DisableColliderComponent from "@inter-ikea-storagetwo/range/dist/components/DisableColliderComponent";
export default class ToggleCollidersOnUprightDragSystem extends SystemBase {
    constructor() {
        super(ComponentIds.IS_DRAGGED_COMPONENT_ID);
        this.doingChangesOnComponent = [];
        this.id = "ToggleCollidersOnUprightDragSystem";
        this.systemsAfterMe = [];
        this.systemsBeforeMe = [];
        this.mandatoryComponents = [COMPONENT_IDS.UPRIGHT_COMPONENT];
        this.entitiesWithColliders = [];
    }
    onAddComponent(_entity, _newComponent) {
        getAffectedInserts(_entity).forEach((child) => child.addComponent(new DisableColliderComponent()));
    }
    onRemoveComponent(_entity, _oldComponent) {
        getAffectedInserts(_entity).forEach((child) => child.removeComponent(COMPONENT_IDS.DISABLED_COLLIDER_COMPONENT));
    }
}
